import { DashboardDefault } from './DashboardDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

DashboardDefault.Navbar = LogoLayoutNavbar;

export default DashboardDefault;
